import { createStandardAction } from 'typesafe-actions';

export const changeLocale = createStandardAction('LOCALE_CHANGE')<LocaleType>();
